// React
import { memo } from "react";

// Helpers
import moment from "moment";

import { REJECTION_REASON_TYPE_LABELS } from "./consts";
import { InvoiceIncomingDecisionInfoProps } from "./types";

const formatDateTime = (date: Date | null): string =>
  date ? moment(date).format("DD.MM.YYYY. HH:mm") : "";

/**
 * Sudbina odluke o e-računu. Odluka ide dalje od naše baze — javlja se provideru i (kod odbijanja)
 * fiskalizira kod Porezne, pa korisnik mora vidjeti je li taj dio prošao. Porijeklo računa stoji
 * kao oznaka uz naslov kartice, a raspored troškova iznad stavki.
 */
const InvoiceIncomingDecisionInfo: React.FC<InvoiceIncomingDecisionInfoProps> = (props) => {
  const { invoice } = props;

  const hasDecision = !!(invoice.processStatusReportedAt || invoice.rejectionFiscalizedAt || invoice.rejectionReason);
  if (!hasDecision) return null;

  const reasonTypeLabel = invoice.rejectionReasonType
    ? REJECTION_REASON_TYPE_LABELS[invoice.rejectionReasonType] ?? invoice.rejectionReasonType
    : null;

  return (
    <div className="px-4 mt-4">
      <div className="border border-slate-200 bg-slate-50 px-4 py-3 text-sm">
        {invoice.processStatusReportedAt && (
          <div className="text-slate-900">
            Odluka javljena provideru{" "}
            <span className="text-slate-500">{formatDateTime(invoice.processStatusReportedAt)}</span>
          </div>
        )}

        {invoice.rejectionFiscalizedAt && (
          <div className="text-slate-900 mt-1">
            Odbijanje fiskalizirano{" "}
            <span className="text-slate-500">{formatDateTime(invoice.rejectionFiscalizedAt)}</span>
          </div>
        )}

        {invoice.rejectionReason && (
          <div className="text-slate-500 mt-1">
            Razlog{reasonTypeLabel ? ` (${reasonTypeLabel})` : ""}: {invoice.rejectionReason}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(InvoiceIncomingDecisionInfo);
